import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(({ theme }) => ({
    root: {
        '& .MuiToggleButton-root': {
            border: 0,
            borderRadius: 0,
            textTransform: 'none',
            height: '24px',
            color: '#BAC0D0',
            fontSize: '1rem',
            fontWeight: 400,
            marginRight: '32px',
            padding: 0,
        },
        '& .MuiToggleButton-root.Mui-selected': {
            fontWeight: 700,
            color: '#1891F6',
            backgroundColor: 'transparent',
            borderBottom: 'solid 2px #1891F6',
        },
        '& .MuiToggleButton-root:hover': {
            backgroundColor: 'transparent',
        },
    },
}));